import { render, staticRenderFns } from "./BrandSegmentComponent.vue?vue&type=template&id=5546bfb2&scoped=true"
import script from "./BrandSegmentComponent.vue?vue&type=script&lang=js"
export * from "./BrandSegmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546bfb2",
  null
  
)

export default component.exports